import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SiteWeatherConfiguration = new Record({
  id: undefined,
  site: undefined,
  weather_enabled: undefined,
  weather_range_km: undefined,
  weather_sensitivity: undefined,
  schedule: undefined,
  relays: undefined,
  invert_operation: undefined,
});

export const siteWeatherConfigurationSchema = new schema.Entity('siteWeatherConfigurations');
